import React, { useState } from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { AssetFutureValueResponse } from 'services/assets';
import AssetFVMergedScheduleTable from './AssetFVMergedScheduleTable';

export type assetfvscheduleProps = Pick<ModalProps, 'onCancel' | 'visible'> & {
  controller?: React.ReactElement;
  currcode?: string;
  fvContext: AssetFutureValueResponse[];
};

const AssetFVMergedScheduleModal = ({
  fvContext = [],
  currcode,
  controller,
  onCancel: onCancelProp,
  visible: visibleProp,
  ...otherProps
}: assetfvscheduleProps) => {
  const [visible, setVisible] = useState(false);

  return (<>
    {controller &&
      React.cloneElement(controller, { onClick: () => setVisible(true) })}
    <Modal
      title={<GetLabel label="AssetFutureValueschedule" />}
      footer={null}
      width={1200}
      style={{ top: '20px', height: '400px' }}
      open={controller ? visible : visibleProp}
      onCancel={controller ? () => setVisible(false) : onCancelProp}
      {...otherProps}
    >
      <AssetFVMergedScheduleTable
        allContext={fvContext}
        currcode={currcode!}
      />
    </Modal>
  </>);
};

export default AssetFVMergedScheduleModal;
